import React from 'react'
import './Info.css'
import Footer from '../UIElements/Footer'
import InfoHomeNavigation from '../../../players/components/InfoHomeNavigation'

import Dec24 from './../../components/documents/Meeting Minutes Dec 18 2024.pdf'
import Feb25 from './../../components/documents/Meeting Minutes Feb 19 2025.pdf'
import Mar25 from './../../components/documents/Meeting Minutes Mar 27 2025.pdf'
import handbook from './../../components/documents/2027 Screaming Eagles Parent Player Handbook.pdf'
import bylaws from './../../components/documents/Bylaws - Screaming Eagles.pdf'

const InfoRow = ({ href, title, subtitle }) => {
	return (
		<a className='infoRow' href={href} target='_blank' rel='noreferrer'>
			<div className='infoRowLeft'>
				<div className='infoIcon' aria-hidden='true'>
					{/* Doc icon */}
					<svg viewBox='0 0 24 24' width='22' height='22'>
						<path
							fill='currentColor'
							d='M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1.5V7h3.5L14 3.5zM7 11h10v2H7v-2zm0 4h10v2H7v-2z'
						/>
					</svg>
				</div>

				<div className='infoRowText'>
					<div className='infoRowTitle'>{title}</div>
					{subtitle ? <div className='infoRowSubtitle'>{subtitle}</div> : null}
				</div>
			</div>

			<div className='infoChevron' aria-hidden='true'>
				<svg viewBox='0 0 24 24' width='22' height='22'>
					<path fill='currentColor' d='M9 6l6 6-6 6' />
				</svg>
			</div>
		</a>
	)
}

const InfoSection = ({ label, children }) => {
	return (
		<div className='infoSection'>
			<div className='infoSectionHeader'>
				<div className='infoSectionLabel'>{label}</div>
				<div className='infoSectionRule' />
			</div>
			<div className='infoCard'>{children}</div>
		</div>
	)
}

const Info = () => {
	const rulesURL =
		'https://usaballhockey.com/wp-content/uploads/2024/11/USA-Ball-Hockey-Official-Rule-Book-Revised-07.06.2021.pdf'

	const resources = [
		{
			href: rulesURL,
			title: 'USA Ball Hockey Official Rule Book',
			subtitle: 'Governing body rules',
		},
		{
			href: 'https://www.pbhl.org/',
			title: 'PBHL Website',
			subtitle: 'League website',
		},
		{
			href: bylaws,
			title: '2026 Screaming Eagles Bylaws',
			//subtitle: 'Bylaws',
		},
		{
			href: handbook,
			title: '2027 Screaming Eagles Handbook',
			subtitle: 'Parent & player handbook',
		},
	]

	const meetingMinutesByYear = {
		2025: [
			{ href: Mar25, title: 'Meeting Minutes', subtitle: 'March 27, 2025' },
			{ href: Feb25, title: 'Meeting Minutes', subtitle: 'February 19, 2025' },
		],
		2024: [
			{ href: Dec24, title: 'Meeting Minutes', subtitle: 'December 18, 2024' },
		],
	}

	return (
		<div className='infoPage'>
			<InfoHomeNavigation />

			{/* Centered content column */}
			<div className='infoContent'>
				<InfoSection label='OFFICIAL DOCUMENTS & LINKS'>
					{resources.map((d) => (
						<InfoRow
							key={d.title}
							href={d.href}
							title={d.title}
							subtitle={d.subtitle}
						/>
					))}
				</InfoSection>

				<InfoSection label='MEETING MINUTES'>
					{Object.keys(meetingMinutesByYear)
						.sort((a, b) => Number(b) - Number(a))
						.map((year) => (
							<div key={year} className='infoYearBlock'>
								<div className='infoYearLabel'>{year}</div>
								<div className='infoYearList'>
									{meetingMinutesByYear[year].map((m) => (
										<InfoRow
											key={`${year}-${m.subtitle}`}
											href={m.href}
											title={m.title}
											subtitle={m.subtitle}
										/>
									))}
								</div>
							</div>
						))}
				</InfoSection>
			</div>

			{/* Full-width footer (IMPORTANT: outside centered column) */}
			<Footer />
		</div>
	)
}

export default Info
